export const en = {
  'shell.nav.reviews': 'Reviews',
  'shell.nav.myReviews': 'My reviews',
  'enum.reviewStatus.DRAFT': 'Draft',
  'enum.reviewStatus.SHARED': 'Shared',
  'enum.reviewStatus.ACKNOWLEDGED': 'Acknowledged',
  'enum.warningLevel.VERBAL': 'Verbal warning',
  'enum.warningLevel.WRITTEN': 'Written warning',
  'enum.warningLevel.FINAL': 'Final warning',
  'admin.apiError.ALREADY_ACKNOWLEDGED': 'This was already acknowledged.',
  'admin.apiError.REVIEW_NOT_DRAFT': 'This review has been shared, so it can no longer change.',
  'admin.apiError.REVIEW_SETUP_GYM_WIDE': 'The review criteria and cycle are the same for the whole gym. Ask someone who works at every branch, such as HR, to change them.',
  'admin.apiError.UNKNOWN_CRITERION': 'One of the ratings is for a criterion the gym no longer uses. Reload and rate again.',
  'reviews.title': 'Reviews',
  'reviews.description': 'Write each person’s review when it falls due, share it with them, and keep a record of any warnings.',
  'reviews.new': 'Write a review',
  'reviews.newTitle': 'Review of {name}',
  'reviews.editTitle': 'Review of {name}',
  'reviews.draftHint': 'Saved as a draft only managers see, until you share it. Once shared it no longer changes.',
  'reviews.saveDraft': 'Save draft',
  'reviews.share': 'Share',
  'reviews.shareTitle': 'Share the review with {name}?',
  'reviews.shareDescription': 'They will be told they have a new document to read, and the review can no longer be changed.',
  'reviews.saved': 'Draft saved',
  'reviews.sharedDone': 'Review shared with {name}',
  'reviews.deleted': 'Draft deleted',
  'reviews.continueDraft': 'Continue',
  'reviews.deleteDraft': 'Delete draft',
  'reviews.deleteDraftTitle': 'Delete this draft?',
  'reviews.deleteDraftDescription': 'Nobody has seen it yet; it is gone for good.',
  'reviews.field.periodStart': 'Period from',
  'reviews.field.periodEnd': 'Period to',
  'reviews.periodBackwards': 'The period cannot end before it starts',
  'reviews.field.strengths': 'Strengths',
  'reviews.field.improvements': 'To improve',
  'reviews.field.goals': 'Goals for the next period',
  'reviews.ratings': 'Ratings',
  'reviews.ratingsHint': '1 is poor and 5 is excellent. Leave a criterion out if it does not apply.',
  'reviews.scoreOf': '{score} out of {max}',
  'reviews.average': 'Average {score}',
  'reviews.by': 'by {name}',
  'reviews.sharedOn': 'shared {date}',
  'reviews.acknowledgedOn': 'acknowledged {date}',
  'reviews.notAcknowledged': 'not acknowledged yet',
  'reviews.employeeComment': 'Their comment',
  'reviews.empty': 'No reviews yet',
  'reviews.emptyHint': 'Write the first one when it falls due.',
  'reviews.tab.reviews': 'Reviews',
  'reviews.tab.warnings': 'Warnings',
  'reviews.tab.timeline': 'Timeline',
  'reviews.due.overdue': 'Overdue since {date}',
  'reviews.due.today': 'Due today',
  'reviews.due.inDays.one': 'Due in {count} day',
  'reviews.due.inDays.other': 'Due in {count} days',
  'reviews.due.on': 'Due {date}',
  'reviews.dueCard.title': 'Reviews due',
  'reviews.dueCard.description': 'Reviews that fall due within 30 days, and any that are overdue.',
  'reviews.dueCard.all': 'All reviews',
  'reviews.people.name': 'Person',
  'reviews.people.next': 'Next review',
  'reviews.people.last': 'Last reviewed',
  'reviews.people.warnings': 'Warnings',
  'reviews.people.never': 'Never',
  'reviews.people.draftStarted': 'draft started',
  'reviews.people.openWarnings.one': '{count} warning',
  'reviews.people.openWarnings.other': '{count} warnings',
  'reviews.people.empty': 'Nobody to review',
  'reviews.people.emptyHint': 'People who work at your branches appear here.',
  'reviews.warning.issue': 'Issue a warning',
  'reviews.warning.newTitle': 'Warning for {name}',
  'reviews.warning.newHint': 'Only you, the others who manage reviews at their branch, and {name} will see it. They are told only that they have a new document to read.',
  'reviews.warning.level': 'Level',
  'reviews.warning.reason': 'Reason',
  'reviews.warning.reasonHint': 'One line, for example “Left the desk unattended”',
  'reviews.warning.details': 'Details',
  'reviews.warning.expires': 'Stops counting after',
  'reviews.warning.expiresHint': 'Optional. It stays on record either way.',
  'reviews.warning.issued': 'Warning issued to {name}',
  'reviews.warning.issuedBy': 'Issued by {name}, {date}',
  'reviews.warning.expiresOn': 'counts until {date}',
  'reviews.warning.expiredOn': 'stopped counting {date}',
  'reviews.warning.expiredLevel': '{level} (expired)',
  'reviews.warning.empty': 'No warnings',
  'reviews.warning.emptyHint': 'Warnings issued to this person appear here.',
  'reviews.timeline.empty': 'Nothing on the timeline yet',
  'reviews.timeline.review': 'Review for {period}: {status}',
  'reviews.timeline.warning': '{level}: {reason}',
  'reviews.timeline.award': 'Award: {title}',
  'reviews.timeline.kudo': 'Kudos: {message}',
  'reviews.setup.open': 'Criteria and cycle',
  'reviews.setup.title': 'Review criteria and cycle',
  'reviews.setup.description': 'The same for every branch. Each person is reviewed on these criteria, from 1 to 5.',
  'reviews.setup.cycle': 'Review every (months)',
  'reviews.setup.cycleHint': 'Counted from each person’s start date. Reviewers are reminded 7 days before.',
  'reviews.setup.criteria': 'Criteria',
  'reviews.setup.labelEn': 'In English',
  'reviews.setup.labelKa': 'In Georgian',
  'reviews.setup.inUse': 'In use',
  'reviews.setup.add': 'Add a criterion',
  'reviews.setup.keepHint': 'A criterion taken out of use stays on the reviews that already used it.',
  'reviews.setup.saved': 'Review setup saved',
  'reviews.mine.title': 'My reviews',
  'reviews.mine.description': 'Reviews and warnings shared with you. Read each one, acknowledge it, and add a comment if you wish.',
  'reviews.mine.empty': 'Nothing shared with you yet',
  'reviews.mine.emptyHint': 'When your manager shares a review with you, it appears here.',
  'reviews.mine.noReviews': 'No reviews yet.',
  'reviews.mine.noWarnings': 'No warnings.',
  'reviews.mine.comment': 'Your comment',
  'reviews.mine.commentHint': 'Optional. It is kept beside the record.',
  'reviews.mine.acknowledge': 'Acknowledge',
  'reviews.mine.acknowledged': 'Acknowledged',
};

export const ka: Record<keyof typeof en, string> = {
  'shell.nav.reviews': 'შეფასებები',
  'shell.nav.myReviews': 'ჩემი შეფასებები',
  'enum.reviewStatus.DRAFT': 'მონახაზი',
  'enum.reviewStatus.SHARED': 'გაზიარებული',
  'enum.reviewStatus.ACKNOWLEDGED': 'დადასტურებული',
  'enum.warningLevel.VERBAL': 'სიტყვიერი გაფრთხილება',
  'enum.warningLevel.WRITTEN': 'წერილობითი გაფრთხილება',
  'enum.warningLevel.FINAL': 'საბოლოო გაფრთხილება',
  'admin.apiError.ALREADY_ACKNOWLEDGED': 'ეს უკვე დადასტურებულია.',
  'admin.apiError.REVIEW_NOT_DRAFT': 'შეფასება უკვე გაზიარებულია და აღარ იცვლება.',
  'admin.apiError.REVIEW_SETUP_GYM_WIDE': 'შეფასების კრიტერიუმები და პერიოდულობა მთელი დარბაზისთვის ერთია. შეცვლა სთხოვეთ ყველა ფილიალში მომუშავეს, მაგალითად HR-ს.',
  'admin.apiError.UNKNOWN_CRITERION': 'ერთ-ერთი შეფასება ეხება კრიტერიუმს, რომელსაც დარბაზი აღარ იყენებს. განაახლეთ გვერდი და შეაფასეთ ხელახლა.',
  'reviews.title': 'შეფასებები',
  'reviews.description': 'შეაფასეთ თითოეული თანამშრომელი დროულად, გაუზიარეთ შეფასება და აღრიცხეთ გაფრთხილებები.',
  'reviews.new': 'შეფასების დაწერა',
  'reviews.newTitle': 'შეფასება: {name}',
  'reviews.editTitle': 'შეფასება: {name}',
  'reviews.draftHint': 'ინახება მონახაზად, რომელსაც მხოლოდ მენეჯერები ხედავენ, სანამ არ გააზიარებთ. გაზიარების შემდეგ აღარ იცვლება.',
  'reviews.saveDraft': 'მონახაზის შენახვა',
  'reviews.share': 'გაზიარება',
  'reviews.shareTitle': 'გავუზიაროთ შეფასება: {name}?',
  'reviews.shareDescription': 'თანამშრომელი მიიღებს შეტყობინებას, რომ ახალი დოკუმენტი აქვს წასაკითხად, ხოლო შეფასება აღარ შეიცვლება.',
  'reviews.saved': 'მონახაზი შენახულია',
  'reviews.sharedDone': 'შეფასება გაზიარდა: {name}',
  'reviews.deleted': 'მონახაზი წაიშალა',
  'reviews.continueDraft': 'გაგრძელება',
  'reviews.deleteDraft': 'მონახაზის წაშლა',
  'reviews.deleteDraftTitle': 'წავშალოთ მონახაზი?',
  'reviews.deleteDraftDescription': 'ჯერ არავის უნახავს; სამუდამოდ წაიშლება.',
  'reviews.field.periodStart': 'პერიოდი: დან',
  'reviews.field.periodEnd': 'პერიოდი: მდე',
  'reviews.periodBackwards': 'პერიოდი დაწყებამდე ვერ დასრულდება',
  'reviews.field.strengths': 'ძლიერი მხარეები',
  'reviews.field.improvements': 'გასაუმჯობესებელი',
  'reviews.field.goals': 'მიზნები შემდეგი პერიოდისთვის',
  'reviews.ratings': 'შეფასებები',
  'reviews.ratingsHint': '1 ცუდია, 5 — შესანიშნავი. გამოტოვეთ კრიტერიუმი, თუ არ ეხება.',
  'reviews.scoreOf': '{score} {max}-დან',
  'reviews.average': 'საშუალო {score}',
  'reviews.by': 'შეაფასა {name}',
  'reviews.sharedOn': 'გაზიარდა {date}',
  'reviews.acknowledgedOn': 'დადასტურდა {date}',
  'reviews.notAcknowledged': 'ჯერ არ დადასტურებულა',
  'reviews.employeeComment': 'თანამშრომლის კომენტარი',
  'reviews.empty': 'შეფასებები ჯერ არ არის',
  'reviews.emptyHint': 'დაწერეთ პირველი, როცა ვადა დადგება.',
  'reviews.tab.reviews': 'შეფასებები',
  'reviews.tab.warnings': 'გაფრთხილებები',
  'reviews.tab.timeline': 'ისტორია',
  'reviews.due.overdue': 'ვადაგადაცილებულია {date}-დან',
  'reviews.due.today': 'ვადა დღესაა',
  'reviews.due.inDays.one': 'ვადა {count} დღეში',
  'reviews.due.inDays.other': 'ვადა {count} დღეში',
  'reviews.due.on': 'ვადა {date}',
  'reviews.dueCard.title': 'შეფასების ვადები',
  'reviews.dueCard.description': 'შეფასებები, რომელთა ვადაც 30 დღეში დგება, და ვადაგადაცილებულები.',
  'reviews.dueCard.all': 'ყველა შეფასება',
  'reviews.people.name': 'თანამშრომელი',
  'reviews.people.next': 'შემდეგი შეფასება',
  'reviews.people.last': 'ბოლო შეფასება',
  'reviews.people.warnings': 'გაფრთხილებები',
  'reviews.people.never': 'არასდროს',
  'reviews.people.draftStarted': 'მონახაზი დაწყებულია',
  'reviews.people.openWarnings.one': '{count} გაფრთხილება',
  'reviews.people.openWarnings.other': '{count} გაფრთხილება',
  'reviews.people.empty': 'შესაფასებელი არავინაა',
  'reviews.people.emptyHint': 'აქ ჩანან თქვენს ფილიალებში მომუშავეები.',
  'reviews.warning.issue': 'გაფრთხილების მიცემა',
  'reviews.warning.newTitle': 'გაფრთხილება: {name}',
  'reviews.warning.newHint': 'დაინახავთ მხოლოდ თქვენ, ამ ფილიალში შეფასებების მენეჯერები და თავად თანამშრომელი ({name}). მას მხოლოდ ის ეცნობება, რომ ახალი დოკუმენტი აქვს წასაკითხად.',
  'reviews.warning.level': 'დონე',
  'reviews.warning.reason': 'მიზეზი',
  'reviews.warning.reasonHint': 'ერთი წინადადება, მაგალითად „სამუშაო ადგილი უყურადღებოდ დატოვა“',
  'reviews.warning.details': 'დეტალები',
  'reviews.warning.expires': 'ძალაშია ამ დღემდე',
  'reviews.warning.expiresHint': 'არასავალდებულოა. ჩანაწერი ნებისმიერ შემთხვევაში რჩება.',
  'reviews.warning.issued': 'გაფრთხილება მიეცა: {name}',
  'reviews.warning.issuedBy': 'მისცა {name}, {date}',
  'reviews.warning.expiresOn': 'ძალაშია {date}-მდე',
  'reviews.warning.expiredOn': 'ძალა დაკარგა {date}',
  'reviews.warning.expiredLevel': '{level} (ვადაგასული)',
  'reviews.warning.empty': 'გაფრთხილებები არ არის',
  'reviews.warning.emptyHint': 'აქ ჩანს ამ თანამშრომლისთვის მიცემული გაფრთხილებები.',
  'reviews.timeline.empty': 'ისტორია ჯერ ცარიელია',
  'reviews.timeline.review': 'შეფასება, {period}: {status}',
  'reviews.timeline.warning': '{level}: {reason}',
  'reviews.timeline.award': 'ჯილდო: {title}',
  'reviews.timeline.kudo': 'მადლობა: {message}',
  'reviews.setup.open': 'კრიტერიუმები და პერიოდი',
  'reviews.setup.title': 'შეფასების კრიტერიუმები და პერიოდულობა',
  'reviews.setup.description': 'ყველა ფილიალისთვის ერთია. თითოეული თანამშრომელი ფასდება ამ კრიტერიუმებით, 1-დან 5-მდე.',
  'reviews.setup.cycle': 'შეფასება ყოველ (თვე)',
  'reviews.setup.cycleHint': 'ითვლება თითოეულის დაწყების თარიღიდან. შემფასებელი შეხსენებას იღებს 7 დღით ადრე.',
  'reviews.setup.criteria': 'კრიტერიუმები',
  'reviews.setup.labelEn': 'ინგლისურად',
  'reviews.setup.labelKa': 'ქართულად',
  'reviews.setup.inUse': 'გამოიყენება',
  'reviews.setup.add': 'კრიტერიუმის დამატება',
  'reviews.setup.keepHint': 'გამოყენებიდან ამოღებული კრიტერიუმი რჩება იმ შეფასებებში, სადაც უკვე გამოიყენეს.',
  'reviews.setup.saved': 'შეფასების პარამეტრები შენახულია',
  'reviews.mine.title': 'ჩემი შეფასებები',
  'reviews.mine.description': 'თქვენთვის გაზიარებული შეფასებები და გაფრთხილებები. წაიკითხეთ, დაადასტურეთ და, სურვილისამებრ, დაურთეთ კომენტარი.',
  'reviews.mine.empty': 'თქვენთვის ჯერ არაფერი გაზიარებულა',
  'reviews.mine.emptyHint': 'როცა მენეჯერი შეფასებას გაგიზიარებთ, აქ გამოჩნდება.',
  'reviews.mine.noReviews': 'შეფასებები ჯერ არ არის.',
  'reviews.mine.noWarnings': 'გაფრთხილებები არ არის.',
  'reviews.mine.comment': 'თქვენი კომენტარი',
  'reviews.mine.commentHint': 'არასავალდებულოა. ინახება ჩანაწერთან ერთად.',
  'reviews.mine.acknowledge': 'დადასტურება',
  'reviews.mine.acknowledged': 'დადასტურებულია',
};
